import { render, staticRenderFns } from "./Criteres.vue?vue&type=template&id=22b254b4&"
import script from "./Criteres.vue?vue&type=script&lang=js&"
export * from "./Criteres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports